import * as React from 'react';
import { Controller, ControllerProps, FieldPath, FieldValues } from 'react-hook-form';

type RenderWithWarning<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>> = (
  props: Parameters<NonNullable<ControllerProps<TFieldValues, TName>['render']>>[0] & { warning: string | boolean }
) => ReturnType<NonNullable<ControllerProps<TFieldValues, TName>['render']>>;

type Props<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>> = Omit<
  ControllerProps<TFieldValues, TName>,
  'render'
> & {
  render: RenderWithWarning<TFieldValues, TName>;

  warn: (value: string) => boolean | string;
};

function PowerController<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>(
  props: Props<TFieldValues, TName>
) {
  return (
    <Controller
      control={props.control}
      name={props.name}
      defaultValue={props.defaultValue}
      render={(innerProps) => {
        const isDirty = innerProps.fieldState.isDirty;
        const isTouched = innerProps.fieldState.isTouched;
        return props.render({
          ...innerProps,
          warning: isDirty && isTouched ? props.warn(innerProps.field.value) : false
        });
      }}
    />
  );
}

export default PowerController;
